import '../Styles/MobileAccountNavBar.css'

import { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../../../Providers/AuthProvider";
import { useTranslation } from "react-i18next";
import { FiLogOut } from "react-icons/fi";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { AccountCurrentView } from "../../../Data/PageModeEnums.ts";

/**
 * JK3 : Wywołuj ten komponent z propsami: currentKey = klucz aktywnej zakładki
 * @param {*} currentKey klucz aktywnej zakładki
 * @returns 
 */
const MobileAccountNavBar = ({ currentKey }) => {
    const [showUserMenu, setShowUserMenu] = useState(false);
    const ref = useRef(null);
    const { authState, logout } = useAuth()
    const { t } = useTranslation()

    // Domknięcie po kliknięciu poza menu
    useEffect(() => {
        function handleClick(e) {
            if (ref.current && !ref.current.contains(e.target)) setShowUserMenu(false);
        }
        if (showUserMenu) document.addEventListener("mousedown", handleClick);
        else document.removeEventListener("mousedown", handleClick);
        return () => document.removeEventListener("mousedown", handleClick);
    }, [showUserMenu]);

    const getCurrentHeader = () => {
        switch (currentKey) {
            case AccountCurrentView.MojeKonto:
                return authState.user.isOperator ? t('my_account_navigation_PH') : t('my_account_navigation')
            case AccountCurrentView.Finanse:
                return t('invoices_navigation')
            case AccountCurrentView.Zamowienia:
                return t('orders_navigation')
            case AccountCurrentView.Oferty:
                return t('offers_navigation')
            case AccountCurrentView.Kontrahenci:
                return t('customers_navigation')
            case AccountCurrentView.ZapisaneKoszyki:
                return 'Szybkokoszyki'
            case AccountCurrentView.ZdarzeniaCRM:
                return 'Zdarzenia CRM'
            case AccountCurrentView.PanelAdministratora:
                return 'Panel Administratora'
            case AccountCurrentView.OfertaHandlowaZPrzykładowymiIndeksami:
                return 'Oferta handlowa z przykładowymi indeksami'
        }
    }

    return (
        <div className="dropdown-account-menu-container" ref={ref}>
            <button
                className={`account-menu-main-btn ${showUserMenu ? "active" : ""}`}
                onClick={() => setShowUserMenu(o => !o)}
                type="button"
            >
                {getCurrentHeader()}
                {showUserMenu ? <IoIosArrowUp size={20} /> : <IoIosArrowDown size={20} />}
            </button>
            {showUserMenu && (
                <ul className="account-dropdown-list">
                    <UserMenu
                        t={t}
                        currentKey={currentKey}
                        setShowUserMenu={setShowUserMenu}
                        authState={authState}
                    />
                    <div className='account-dropdown-logout-btn' onClick={() => { setShowUserMenu(false); logout(); }} >
                        {t('logout_navigation')}
                        <FiLogOut style={{ marginLeft: 20 }} />
                    </div>
                </ul>
            )}
        </div>
    );
}

const UserMenu = ({ t, setShowUserMenu, authState, currentKey }) => {
    return (
        <>
            {(!authState.user.isOperator || (authState.user.isOperator && authState.selectedCustomer !== null)) && currentKey != AccountCurrentView.MojeKonto ? (
                <div onClick={() => setShowUserMenu(false)}>
                    <Link to={AccountCurrentView.MojeKonto} className='link'>
                        <span className='ms-1'>{authState.user.isOperator ? t('my_account_navigation_PH') : t('my_account_navigation')}</span>
                    </Link>
                </div>
            ) : <></>}
            {currentKey != AccountCurrentView.Finanse && <div onClick={() => setShowUserMenu(false)}>
                <Link to={AccountCurrentView.Finanse} className='link'>
                    <span className='ms-1'>{t('invoices_navigation')}</span>
                </Link>
            </div>}
            {currentKey != AccountCurrentView.Zamowienia && <div onClick={() => setShowUserMenu(false)}>
                <Link to={AccountCurrentView.Zamowienia} className='link'>
                    <span className='ms-1'>{t('orders_navigation')}</span>
                </Link>
            </div>}
            {currentKey != AccountCurrentView.Oferty && <div onClick={() => setShowUserMenu(false)}>
                <Link to={AccountCurrentView.Oferty} className='link'>
                    <span className='ms-1'>{t('offers_navigation')}</span>
                </Link>
            </div>}
            {authState.user.isOperator && currentKey != AccountCurrentView.Kontrahenci && (
                <div onClick={() => setShowUserMenu(false)}>
                    <Link to={AccountCurrentView.Kontrahenci} className='link'>
                        <span className='ms-1'>{t('customers_navigation')}</span>
                    </Link>
                </div>
            )}
            {currentKey != AccountCurrentView.ZapisaneKoszyki && <div onClick={() => setShowUserMenu(false)}>
                <Link to={AccountCurrentView.ZapisaneKoszyki} className='link'>
                    <span className='ms-1'>Szybkokoszyki</span>
                </Link>
            </div>}
            {currentKey != AccountCurrentView.ZdarzeniaCRM && authState.user.isOperator && Number(authState.user.upR_SYS_OBSLUGA_KONTAKTOW) > 0 && authState.custId &&
                <div onClick={() => setShowUserMenu(false)}>
                    <Link to={AccountCurrentView.ZdarzeniaCRM} className='link'>
                        <span className='ms-1'>Zdarzenia CRM</span>
                    </Link>
                </div>}
            {currentKey != AccountCurrentView.PanelAdministratora && authState.user.isOperator && authState.user.upR_ADMIN &&
                <div onClick={() => setShowUserMenu(false)}>
                    <Link to={AccountCurrentView.PanelAdministratora} className='link'>
                        <span className='ms-1'>Panel administratora</span>
                    </Link>
                </div>}
        </>
    )
}

export default MobileAccountNavBar
